import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Layout from "../components/layout";

const useStyles = makeStyles((theme) => ({
  box1: {
    display: "grid",
    gridGap: "50px 100px",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
      justifyItems: "center",
      gridTemplateColumns: "1fr 1fr",
    },
  },
  image: {
    maxHeight: 320,
    maxWidth: "100%",
    objectFit: "contain",
    margin: "auto",
  },
  box2: {
    textAlign: "center",
    [theme.breakpoints.up("md")]: {
      textAlign: "left",
    },
  },
}));

export default function Customers() {
  const classes = useStyles();

  return (
    <Layout>
      <div style={{ padding: "60px 0" }}>
        <Container>
          <div className={classes.box1}>
            <img src="/media/404.png" alt="" className={classes.image} />
            <div className={classes.box2}>
              <h1>Page not found</h1>
              <p>Oops! The page you are looking for does not exist.</p>
              <p style={{ fontSize: 18 }}>
                <a href="/">Goto Home page</a>
              </p>
            </div>
          </div>
        </Container>
      </div>
    </Layout>
  );
}
